import { inject, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { setDeserializedAppState } from 'Angular/state/app-state/app-state.actions';
import { AppStateService } from 'Angular/services/app-state.service';
import * as i0 from "@angular/core";
export class AgentLinkNavigatorService {
    constructor() {
        this.router = inject(Router);
        this.store = inject(Store);
        // Look up AppStateService lazily — it depends on ActivatedRoute, which
        // pages without a router don't provide, so eager injection would crash
        // the agent panel on those pages.
        this.injector = inject(Injector);
    }
    async navigateToParams(params, fallbackHref) {
        try {
            // If the page uses App State, dispatch state directly so its
            // URL↔store cascade does the single canonical history push.
            // Otherwise navigate — no cascade means one push is back-safe.
            const appStateService = this.tryGetAppStateService();
            if (appStateService && appStateService.urlParamKeys.length > 0) {
                const deserializedAppState = appStateService.deserialize(params);
                this.store.dispatch(setDeserializedAppState({ deserializedAppState }));
            }
            else {
                await this.router.navigate([], {
                    queryParams: params,
                    queryParamsHandling: 'merge',
                });
            }
        }
        catch {
            window.location.href = fallbackHref;
        }
    }
    tryGetAppStateService() {
        try {
            return this.injector.get(AppStateService);
        }
        catch {
            return null;
        }
    }
}
AgentLinkNavigatorService.ɵfac = function AgentLinkNavigatorService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentLinkNavigatorService)(); };
AgentLinkNavigatorService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentLinkNavigatorService, factory: AgentLinkNavigatorService.ɵfac, providedIn: 'root' });
